var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"RedirectModal"}},[_c('div',{staticClass:"brand-text"},[_vm._v(" Sorry, your secure session expired, please start your journey again. ")])])
}]

export { render, staticRenderFns }